import React from 'react'
import * as XLSX from 'xlsx';

const PrintToXLS = ({ headers, data, docTitle, hasMonth, footerValues }) => {

  const handlePrintXLS = () => {
    const sheetData = [
      headers.map(header => header.label),
      ...data.map(item => headers.map(header => item[header.key]))
    ];

    if (hasMonth) {
      sheetData.unshift(['Mês de Referência:', hasMonth]);
    }

    if (footerValues && Array.isArray(footerValues)) {
      sheetData.push([...footerValues]);
    }

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${docTitle}.xlsx`);
  }

  return (
    <button
      onClick={handlePrintXLS}
      className="inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 min-w-[120px]"
    >
      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
      </svg>
      Gerar XLS
    </button>
  )
}

export default PrintToXLS